export const nlData = `
<div class="paragraph">
    <div class="title">ALGEMENE VOORWAARDEN</div>
    <div class="text-box">
      <div class="text">
        <br>
        Deze inruilservice ("Service") wordt geleverd door Danghuan Europe S.L., een
        vennootschap opgericht naar Spaans recht en geregistreerd te Madrid, Spanje (28045),
        BTW-nummer B19961911 (hierna "Danghuan"), met e-mailadres legal@danghuan.eu.
        De ONEPLUS-entiteiten, Reflection Investment B.V. voor Spanje en Frankrijk en
        Unumplus Limited voor het Verenigd Koninkrijk (samen "ONEPLUS"), promoten de
        beschikbaarheid van deze Inruilservice op hun respectieve officiële websites. ONEPLUS
        beheert, verwerkt of voert echter geen enkel deel van het inruilprogramma zelf uit.
        <br><br>
        Dit document bepaalt de voorwaarden waaronder consumenten die in de Europese Unie
        wonen, kunnen deelnemen aan het officiële inruilprogramma voor bepaalde
        smartphone-aankopen. Het programma wordt uitgevoerd in volledige overeenstemming
        met het recht van de Europese Unie, met name Richtlijn 2011/83/EU inzake
        consumentenrechten en Verordening (EU) 2016/679 (AVG) inzake
        gegevensbescherming.
        <br><br>
        Voor consumenten die in het Verenigd Koninkrijk wonen, wordt het Inruilprogramma
        geregeld volgens het toepasselijke Britse recht, met inbegrip van de Consumer Rights
        Act 2015 en de UK General Data Protection Regulation (UK GDPR), die de bepalingen
        van Verordening (EU) 2016/679 heeft overgenomen in het Britse recht krachtens de Data
        Protection Act 2018.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKEL 1 – TERRITORIALE REIKWIJDTE EN PRODUCTEN</strong>
        <br><br>
        1.1. De inruilservice is beschikbaar voor natuurlijke personen van 18 jaar of ouder die
        rechtmatig woonachtig zijn in een lidstaat van de Europese Unie of in het Verenigd
        Koninkrijk.
        <br><br>
        1.2. Klanten moeten handelen in persoonlijke (niet-professionele) hoedanigheid en
        moeten kwalificeren als "consument" volgens Richtlijn 2011/83/EU (voor EU-inwoners)
        of volgens de Consumer Rights Act 2015 (voor VK-inwoners).
        <br><br>
        1.3. Per in aanmerking komende transactie mag slechts één gebruikt toestel worden
        ingeruild.
        <br><br>
        1.4. De inruilservice is uitsluitend beschikbaar voor klanten die een in aanmerking
        komend ONEPLUS-product ("Product") aanschaffen via de officiële ONEPLUS-
        webwinkels in Frankrijk, Spanje of het Verenigd Koninkrijk tijdens de toepasselijke
        campagneperiode. Alleen specifiek aangewezen ONEPLUS-modellen komen in
        aanmerking.
        <br><br>
        1.5. Het ingeruilde toestel moet voorkomen op de lijst van in aanmerking komende
        modellen die op de officiële website is gepubliceerd en moet voldoen aan de functionele
        en eigendomseisen zoals bepaald in Artikel 5.
        <br><br>
        1.6. De klant mag slechts één (1) gebruikt toestel aanleveren voor elk gekocht Product.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKEL 2 – CONTRACTUELE VOORWAARDEN</strong>
        <br><br>
        2.1. De inruilservice functioneert onafhankelijk van de aankoop van enig Product en
        vormt geen gebundeld of gezamenlijk aanbod met een fabrikant, distributeur of
        wederverkoper.
        <br><br>
        2.2. Alle operationele verantwoordelijkheden met betrekking tot de Service — waaronder
        klantencommunicatie, logistiek van apparaten, waardebepaling, betalingen en
        verwerking van persoonsgegevens — berusten uitsluitend bij Danghuan Europe S.L.
        <br><br>
        2.3. Niets in deze Algemene Voorwaarden beperkt of schaadt de wettelijke rechten die
        aan consumenten worden toegekend krachtens toepasselijke wetgeving, met inbegrip
        van maar niet beperkt tot Richtlijn 2011/83/EU en de Britse Consumer Rights Act 2015.
        <br><br>
        2.4. Danghuan behoudt zich het recht voor om elke inruilaanvraag te weigeren bij
        vermoeden van fraude, misbruik of schending van de Servicevoorwaarden, met inbegrip
        van maar niet beperkt tot inzendingen die namens een andere gebruiker door een derde
        partij worden gedaan.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKEL 3 – DEELNAMEPROCES VAN DE SERVICE</strong>
        <br><br>
        3.1. Klanten kunnen zich tijdens het afrekenproces op de aangewezen ONEPLUS-
        webshop aanmelden voor de inruilservice.
        <br><br>
        3.2. Om verder te gaan, moet de klant een zelfbeoordelingsvragenlijst invullen en de
        vereiste apparaatgegevens indienen, waaronder maar niet beperkt tot het IMEI-nummer,
        het model en de toestand van het toestel.
        <br><br>
        • Controleer alstublieft of het model van uw oude apparaat correct is geselecteerd.
        Als een wijziging nodig is, neem dan zo snel mogelijk contact met ons op via
        insta360@danghuan.eu, zodat wij de apparaatgegevens kunnen bijwerken.
        <br><br>
        3.3. Klanten moeten op het moment van registratie correcte en geldige bankgegevens
        verstrekken voor de betaling:
        <br><br>
        • Voor inwoners van de EU/EER: een SEPA-conform IBAN-rekeningnummer
        uitgegeven door een financiële instelling binnen de SEPA-zone.
        <br><br>
        • Voor inwoners van het VK: een GBP-rekening op hun naam met Sort Code en
        Account Number, geschikt voor betaling via Faster Payments of BACS.
        <br><br>
        3.4. Klanten ontvangen binnen 24 uur na levering van het nieuwe toestel (zoals
        geregistreerd in het logistieke systeem) een e-mail met instructies voor de
        inruilprocedure.
        <br><br>
        3.5. Klanten moeten alle vereiste documenten uploaden (bijvoorbeeld de ondertekende
        integriteitsverklaring) en het gebruikte toestel binnen 10 kalenderdagen na de
        leveringsdatum van het nieuwe toestel verzenden. Een geldige trackingcode moet
        binnen deze termijn aantonen dat de zending is gestart.
        <br><br>
        3.6. Als de bovenstaande stappen niet binnen de gestelde termijn worden voltooid, wordt
        de inruilaanvraag automatisch geannuleerd.
        <br><br>
        3.7. Onvolledige, inconsistente of onjuiste inzendingen — zoals een niet-
        overeenkomend IMEI-nummer of ontbrekende documentatie — kunnen leiden tot
        afwijzing van de inruil zonder verdere compensatie.
        <br><br>
        3.8. Het gebruikte toestel moet veilig worden verpakt in overeenstemming met de
        verstrekte verzendinstructies. De verzending is vooraf betaald door Danghuan. Bij niet-
        levering of schade tijdens het transport moet de klant binnen 15 kalenderdagen na de
        laatste trackingupdate contact opnemen via insta360@danghuan.eu. Danghuan zal
        vervolgens toegang verlenen tot het officiële UPS-claimkanaal en de klant helpen bij het
        indienen van de claim.
        <br><br>
        Let op: logistieke claims moeten worden ingediend binnen 60 dagen na de
        aanmaakdatum van het verzendlabel. Eventuele goedgekeurde compensatie wordt
        rechtstreeks overgemaakt naar het door de klant opgegeven IBAN-rekeningnummer.
        Danghuan aanvaardt in dergelijke gevallen geen aansprakelijkheid voor terugbetaling.
        <br><br>
        3.9. Toestellen die worden teruggestuurd zonder de vereiste integriteitsverklaring of
        zonder ondertekende verkoopbevestiging worden niet verwerkt. De klant wordt per e-
        mail op de hoogte gebracht en kan binnen 10 kalenderdagen na ontvangst van de
        kennisgeving verzoeken om het toestel terug te krijgen. De verzendkosten voor
        retourzending zijn van toepassing volgens Artikel 6.3. Als binnen deze termijn geen
        verzoek wordt ontvangen, behoudt Danghuan zich het recht voor het toestel op
        verantwoorde wijze te recyclen of te verwijderen zonder verdere verplichting of
        aansprakelijkheid.
        <br><br>
        3.10. In aanmerking komende producten voor inruil omvatten smartphones,
        smartwatches, draadloze oortelefoons en tablets, zoals vermeld en geaccepteerd op de
        officiële ONEPLUS-website op het moment van deelname.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKEL 4 – ACCEPTATIEVOORWAARDEN VAN TOESTELLEN</strong>
        <br><br>
        4.1. Alleen toestellen die vermeld staan op de lijst van in aanmerking komende modellen,
        gepubliceerd op de officiële ONEPLUS-website (waaronder smartphones, smartwatches,
        draadloze oortelefoons en tablets), worden geaccepteerd binnen het Inruilprogramma.
        <br><br>
        4.2. Alle toestellen moeten voldoen aan de beoordelings- en cosmetische standaarden
        zoals vastgesteld door Danghuan. Toestellen worden geclassificeerd als Grade A, B of
        C, op basis van gecertificeerde inspectietools en hun fysieke staat, zoals beschreven in
        Artikel 6.
        <br><br>
        4.3. Toestellen moeten voldoen aan de volgende minimale functionele en fysieke criteria:
        <br><br>
        – Smartphones and Tablets: Het toestel moet kunnen worden ingeschakeld, een goed
        werkend aanraakscherm en batterij hebben, geen ernstige fysieke schade vertonen
        (zoals een gebarsten scherm of corrosie), en volledig zijn teruggezet naar de
        fabrieksinstellingen, waarbij alle beveiligingsvergrendelingen (zoals PIN, Apple iCloud,
        Google FRP, Samsung of Xiaomi) zijn uitgeschakeld.
        <br><br>
        – Smartwatches: Het toestel moet kunnen worden ingeschakeld, vrij zijn van actieve
        accountvergrendelingen (zoals iCloud, Google of Samsung), en correct functioneren
        zonder ernstige fysieke schade.
        <br><br>
        – Draadloze oortelefoons: Beide oortjes en de oplaadcase moeten aanwezig zijn,
        kunnen opladen en koppelen, en mogen geen tekenen van waterschade of structurele
        scheuren vertonen.
        <br><br>
        4.4. Alle toestellen moeten het exclusieve eigendom van de klant zijn en mogen niet
        onder lease-, financierings- of eigendomsrechten van derden vallen. Toestellen die als
        verloren, gestolen, nagemaakt of gemanipuleerd zijn gemeld (bijv. met gewijzigd
        serienummer of IMEI) worden zonder compensatie geweigerd.
        <br><br>
        4.5. Toestellen die niet aan de minimale geschiktheidsvereisten voldoen, kunnen op
        verzoek van de klant binnen 7 dagen na de kennisgeving worden teruggestuurd. De
        kennisgeving wordt per e-mail verzonden. Indien geen verzoek wordt ontvangen, kan
        het toestel op verantwoorde wijze worden gerecycled.
        Wanneer de klant om de retourzending van een dergelijk niet-geschikt toestel verzoekt,
        gelden dezelfde voorwaarden en verzendkosten zoals beschreven in Artikel 6.3.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKEL 5 – LOGISTIEKE TIJDLIJN EN VERPLICHTINGEN</strong>
        <br><br>
        5.1. Klanten moeten hun gebruikte toestel verzenden binnen 10 kalenderdagen na
        ontvangst van het nieuwe ONEPLUS-toestel.
        <br><br>
        5.2. Danghuan verzendt herinnerings-e-mails op dag 3 (D+3), dag 6 (D+6) en dag 9 (D+9)
        na levering.
        <br><br>
        5.3. Alle toestellen moeten worden verzonden met het voorafbetaalde verzendlabel dat
        door Danghuan Europe S.L. is verstrekt.
        <br><br>
        5.4. Indien het verzendlabel niet wordt gescand door de logistieke dienstverlener vóór
        dag 15 (D+14), wordt de inruil automatisch geannuleerd.
        <br><br>
        5.5. Toestellen moeten veilig worden verpakt om schade tijdens transport te voorkomen;
        Danghuan verstrekt verpakkingsinstructies, maar geen fysieke materialen.
        <br><br>
        5.6. Indien het ontvangen toestel een niet-overeenkomend IMEI-nummer heeft of in een
        andere toestand verkeert dan door de klant is opgegeven, kan dit leiden tot aanpassing
        van de waardering of annulering van de inruil.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKEL 6 – INSPECTIE, OFFERTE EN AANVAARDING</strong>
        <br><br>
        6.1. Toestellen worden binnen drie (3) werkdagen na ontvangst in het aangewezen
        magazijn geïnspecteerd. De inspectie omvat zowel functionele diagnose met
        gecertificeerde testapparatuur als een visuele beoordeling om de cosmetische staat
        (Grade A, B of C) te bepalen.
        <br><br>
        6.2. Indien de staat of specificaties van het toestel afwijken van de oorspronkelijke
        opgave van de klant, stuurt Danghuan Europe S.L. een herziene offerte per e-mail, met
        vermelding van de aangepaste graad en de bijbehorende motivatie.
        <br><br>
        6.3. Klanten hebben 7 kalenderdagen vanaf de datum van kennisgeving om de herziene
        inruilofferte te accepteren of te weigeren. Gedurende deze periode kunnen zij ook
        verzoeken om hun toestel terug te laten sturen.
        <br><br>
        • Voor klanten die in Spanje wonen, betaalt Danghuan Europe S.L. de
        retourverzendkosten.
        <br><br>
        • Voor klanten in andere landen is de klant verantwoordelijk voor de
        retourkosten, tot een maximum van €22 (GBP £19 / DKK 165 kr / SEK 245
        kr, inclusief BTW), met gebruik van het officiële voorafbetaalde retourlabel
        dat door Danghuan wordt verstrekt. Betalingsinstructies worden door
        Danghuan meegedeeld via e-mail of betalingslink.
        <br><br>
        Klanten kunnen de retourkosten betalen via:
        <br><br>
        • Voor EU/EER-klanten: SEPA-bankoverschrijving naar het IBAN van Danghuan.
        <br><br>
        • Voor VK-klanten: GBP-bankoverschrijving naar de Britse rekening van
        Danghuan (via Faster Payments of BACS).
        <br><br>
        Indien betaling niet binnen 10 kalenderdagen na verzending van het betalingsverzoek
        wordt ontvangen, behoudt Danghuan zich het recht voor de herziene offerte als
        geaccepteerd te beschouwen en het toestel overeenkomstig te verwerken.
        <br><br>
        Terugbetalingen van door de klant betaalde retourkosten worden binnen 5 werkdagen
        na verificatie van betaling door Danghuan uitgevoerd via bankoverschrijving naar
        hetzelfde rekeningnummer dat tijdens de inruilregistratie werd opgegeven.
        <br><br>
        6.4. Indien de klant niet binnen 7 kalenderdagen reageert op de herziene offerte, zal de
        klantenservice van Danghuan proberen rechtstreeks contact op te nemen ter
        bevestiging van acceptatie of weigering. Indien binnen 30 kalenderdagen na
        kennisgeving geen reactie wordt ontvangen, wordt de herziene offerte als geweigerd
        beschouwd. Daarnaast geldt voor klanten buiten Spanje een retourverzendvergoeding.
        De klant dient deze binnen 5 kalenderdagen na ontvangst van het betalingsverzoek te
        voldoen. Na bevestigde betaling zal Danghuan binnen 5 werkdagen de transactie
        verifiëren en de retourzending organiseren naar het originele adres dat bij de
        inruilregistratie is opgegeven. De klant ontvangt een e-mailbevestiging met de
        verzendgegevens en trackinginformatie zodra het toestel is verzonden.
        <br><br>
        6.5. Toestellen die onherstelbaar beschadigd, gemanipuleerd of niet in aanmerking zijn
        (zoals vergrendeld via iCloud, gestolen, of met niet-overeenkomend IMEI), krijgen geen
        waardering. De klant heeft 7 kalenderdagen vanaf kennisgeving om een retourverzoek
        in te dienen; anders kan het toestel op verantwoorde wijze worden gerecycled.
        <br><br>
        6.6. Betaling voor geaccepteerde toestellen wordt uitgevoerd binnen 3 werkdagen na
        acceptatie, via SEPA-bankoverschrijving.
        <br><br>
        6.7. Beoordelingscriteria voor toestellen:
        <br><br>
        Toestellen worden geëvalueerd en geclassificeerd als volgt. Elke productcategorie
        (smartphone, tablet, smartwatch, oortelefoon) heeft eigen categoriegebonden criteria:
        <br><br>
        I. Smartphones and Tablets
        <br><br>
        Grade A – Uitstekende Staat
        <br><br>
        • Toestel vertoont normale gebruikssporen maar verkeert in goede staat.
        <br><br>
        • Geen barsten, deuken of lakverlies.
        <br><br>
        • Alle functies (scherm, aanraking, camera, knoppen, luidspreker, batterij,
        connectiviteit, enz.) werken correct.
        <br><br>
        • Voor Apple-toestellen: batterijgezondheid ≥ 90%.
        <br><br>
        Grade B – Lichte Gebruikssporen
        <br><br>
        • Toestel vertoont lichte gebruikssporen maar blijft in goede staat.
        <br><br>
        • Mag 2–3 kleine krasjes of lichte schuursporen hebben, zonder grote schade.
        <br><br>
        • Alle hoofdfuncties (display, aanraking, sensoren, Bluetooth) werken normaal.
        <br><br>
        • Voor Apple-toestellen: batterijgezondheid ≥ 80%.
        <br><br>
        Grade C – Zichtbare Gebruikssporen
        <br><br>
        • Toestel vertoont duidelijke slijtage, zoals meerdere krassen, lakslijtage of een
        kleine deuk.
        <br><br>
        • Een lichte barst op het scherm is toegestaan zolang de functionaliteit niet wordt
        beïnvloed.
        <br><br>
        • Alle hoofdfuncties (scherm, aanraking, camera, connectiviteit) blijven
        operationeel.
        <br><br>
        Grade D – Onherstelbaar / Geweigerd
        <br><br>
        • Toestel is zwaar beschadigd of kan niet worden ingeschakeld.
        <br><br>
        • Diepe barsten, gebogen frame, gebroken scherm of behuizing, ontbrekende
        onderdelen, moederbordfout, corrosie, geen beeld of geen aanraking.
        <br><br>
        • Toestel kan niet worden verbonden of getest (bijv. vergrendeld door
        Google/iCloud/PIN).
        <br><br>
        • De batterij van het apparaat is opgezwollen of heeft andere problemen die niet
        aan de veiligheidsnormen voldoen, zoals overmatige oververhitting of een door
        de batterij opengeduwd omhulsel.
        <br><br>
        II. Smartwatches en Polsbanden
        <br><br>
        Grade A – Uitstekende Staat
        <br><br>
        • Toestel vertoont normale gebruikssporen maar verkeert in goede staat.
        <br><br>
        • Geen barsten, lakverlies of verkleuring.
        <br><br>
        • Alle functies (aanraking, kroon, sensoren, Bluetooth, Wi-Fi) werken correct.
        <br><br>
        • Voor Apple-toestellen: batterijgezondheid ≥ 90%.
        <br><br>
        Grade B – Lichte Gebruikssporen
        <br><br>
        • Toestel vertoont lichte gebruikssporen maar blijft in goede staat.
        <br><br>
        • Mag 2–3 kleine krasjes of lichte schuurplekken hebben; geen grote schade.
        <br><br>
        • Alle hoofdfuncties (display, aanraking, sensoren, Bluetooth) werken normaal.
        <br><br>
        • Voor Apple-toestellen: batterijgezondheid ≥ 80%.
        <br><br>
        Grade C – Zichtbare Gebruikssporen
        <br><br>
        • Toestel vertoont zichtbare slijtage zoals meerdere krassen, lakslijtage of kleine
        deuken.
        <br><br>
        • Sommige sensoren of knoppen reageren mogelijk minder goed, maar
        kernfuncties blijven werken.
        <br><br>
        • Batterijduur licht verminderd (< 80%).
        <br><br>
        Grade D – Onherstelbaar / Geweigerd
        <br><br>
        • Toestel is zwaar beschadigd of kan niet worden ingeschakeld.
        <br><br>
        • Gebarsten scherm, defecte knoppen of kroon, moederbordfout,
        accountvergrendeling (iCloud/Google/PIN) of corrosie.
        <br><br>
        • Niet in aanmerking voor inruil.
        <br><br>
        III. Draadloze Oortelefoons
        <br><br>
        Grade A – Uitstekende Staat
        <br><br>
        • Toestel is schoon en vrij van krassen of vlekken.
        <br><br>
        • Alle functies (geluid, aanraking, microfoon, Bluetooth, opladen) werken correct.
        <br><br>
        • Oplaadcase is intact en functioneel.
        <br><br>
        Grade B – Lichte Gebruikssporen
        <br><br>
        • Toestel vertoont lichte gebruikssporen, zoals kleine oppervlakkige vlekken of
        schuurplekken, maar blijft in goede staat.
        <br><br>
        • Geluid en Bluetooth werken stabiel; de oplaadcase kan lichte markeringen
        vertonen.
        <br><br>
        • Aanraak- en microfoonfuncties werken normaal.
        <br><br>
        Grade C – Zichtbare Gebruikssporen
        <br><br>
        • Toestel vertoont duidelijke slijtage, zoals meerdere krassen, kleurvervaging of
        kleine deuken.
        <br><br>
        • Geluid of microfoon kan licht verminderd zijn, maar blijft functioneel.
        <br><br>
        • Bluetooth mogelijk minder stabiel; oplaadcase vertoont zichtbare krassen of
        lichte schade.
        <br><br>
        Grade D – Onherstelbaar / Geweigerd
        <br><br>
        • Toestel is onvolledig, kan niet worden ingeschakeld of voldoet niet aan
        basisfunctionaliteit.
        <br><br>
        • Ontbrekend oortje of case, batterijdefect, gebroken oplaadpoort, geen Bluetooth-
        verbinding of waterschade.
        <br><br>
        • Niet in aanmerking voor inruil.
        <br><br>
        6.8. Indien het ontvangen toestel niet overeenkomt met het model of serienummer dat
        oorspronkelijk door de klant werd opgegeven, neemt Danghuan contact op met de klant
        om een nieuwe offerte te verstrekken. Indien het nieuw ontvangen toestel in aanmerking
        komt voor het Inruilprogramma, wordt een nieuwe waardering opgesteld op basis van
        de feitelijke staat.
        <br><br>
        De klant moet de herziene offerte bekijken en de nieuwe Verklaring van Eigendom en
        Integriteit ondertekenen die bij het ontvangen toestel hoort, voordat de inruil kan
        doorgaan.
        <br><br>
        Indien de klant de nieuwe offerte niet binnen 7 kalenderdagen accepteert, kan hij om
        retour van het verkeerd verzonden toestel verzoeken volgens de voorwaarden van
        Artikel 6.3.
        <br><br>
        6.9. De inruilprocedure vereist dat de klant de Verklaring van Eigendom en Integriteit
        ondertekent en indient voor het ingeruilde toestel. Indien dit document niet correct wordt
        ingevuld, ondertekend of ingediend, kan het inruilverzoek worden afgewezen. In dat
        geval kan het toestel op verzoek van de klant worden teruggestuurd volgens de
        voorwaarden in Artikel 6.3, of op verantwoorde wijze worden gerecycled indien geen
        reactie binnen de gestelde termijn wordt ontvangen.
        <br><br>
        6.10. De initiële inruilofferte blijft 10 kalenderdagen geldig na levering van het nieuwe
        ONEPLUS-toestel. Binnen deze periode kan de klant de inruil afronden zonder wijziging
        van het offertebedrag. Na deze periode kan de waardering worden herzien, aangezien
        de marktwaarde van tweedehands toestellen snel kan fluctueren, met name voor
        toestellen met hoge waarde of vouwbare modellen waarvan de afschrijving sneller
        verloopt.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKEL 7 – BETALINGSVOORWAARDEN</strong>
        <br><br>
        7.1. Uitbetalingen worden uitsluitend gedaan via bankoverschrijving naar een rekening
        op naam van de klant, zoals opgegeven tijdens de registratie van de inruil.
        <br><br>
        7.2. Voor klanten die in de EU of EER wonen, worden betalingen uitgevoerd via SEPA-
        overschrijving naar een geldig IBAN gekoppeld aan een financiële instelling binnen de
        SEPA-zone.
        <br><br>
        7.3. Voor klanten die in het Verenigd Koninkrijk wonen, kunnen betalingen in GBP
        worden gedaan via Faster Payments of BACS naar een Britse bankrekening, op
        voorwaarde dat de rekening op naam van de klant staat en de betaalgegevens volledig
        en correct zijn.
        <br><br>
        7.4. Voorafbetaalde kaarten, virtuele rekeningen of bankgegevens die niet
        overeenkomen met de geregistreerde klantnaam leiden tot betalingsmislukking en
        kunnen resulteren in annulering van de inruiltransactie.
        <br><br>
        7.5. Danghuan Europe S.L. is niet aansprakelijk voor vertragingen of fouten veroorzaakt
        door onvolledige, onjuiste of verlopen bankgegevens.
        <br><br>
        7.6. Indien de klant foutieve, ongeldige of niet-overeenkomende bankgegevens verstrekt
        en de betaling met succes wordt uitgevoerd naar het opgegeven rekeningnummer, is
        Danghuan Europe S.L. niet aansprakelijk voor enig resulterend verlies. De klant
        aanvaardt de volledige verantwoordelijkheid voor de juistheid van zijn bankgegevens. In
        dergelijke gevallen wordt geen tweede betaling uitgevoerd.
        <br><br>
        7.7. Na voltooiing van het inruilproces, indien het terug te betalen bedrag in de bestelling
        lager is dan de toepasselijke inruilbonus, wordt enkel het resterende terugbetaalbare
        bedrag overgemaakt.
        <br><br>
        7.8. Een eventuele inruilbonus wordt geannuleerd indien de bestelling van het Product
        wordt terugbetaald.
        <br><br>
        7.9. Alle bankkosten met betrekking tot inruilbetalingen worden gedragen door
        Danghuan Europe S.L.
        <br><br>
        7.10. Let op: het totale bedrag dat aan de klant wordt uitbetaald, kan bestaan uit twee
        afzonderlijke overschrijvingen:
        <br><br>
        (a) de waarde van het ingeruilde toestel, rechtstreeks betaald door Danghuan; en
        <br><br>
        (b) een eventuele promotionele bonus toegekend door ONEPLUS, die afzonderlijk door
        ONEPLUS wordt overgemaakt naar dezelfde bankrekening zoals door de klant
        opgegeven.
        <br><br>
        De twee betalingen kunnen op verschillende tijdstippen worden ontvangen, afhankelijk
        van de verwerkingstermijnen van beide partijen.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKEL 8 – AANSPRAKELIJKHEID EN RISICO OP VERLIES</strong>
        <br><br>
        8.1. Klanten zijn verplicht gebruik te maken van het voorafbetaalde verzendlabel en de
        aangewezen logistieke dienstverlener die door Danghuan Europe S.L. wordt verstrekt.
        Elk alternatief verzendmiddel buiten dit systeem sluit de aansprakelijkheidsdekking uit.
        <br><br>
        8.2. Een toestel wordt als verloren beschouwd indien het niet wordt gevolgd, bevestigd
        of ontvangen door Danghuan Europe S.L. binnen 15 kalenderdagen na overhandiging
        aan de logistieke dienstverlener.
        <br><br>
        • Voor UPS-zendingen moeten claims worden ingediend binnen 60 dagen na de
        aanmaakdatum van het verzendlabel.
        <br><br>
        • Voor CORREOS-zendingen binnen Spanje moeten claims zo snel mogelijk
        worden ingediend, idealiter binnen 15 dagen, en uiterlijk binnen 1 jaar na de
        verzenddatum.
        <br><br>
        Danghuan ondersteunt klanten bij het indienen van de claim bij de koerier, wat
        doorgaans 30 tot 60 dagen in beslag neemt.
        <br><br>
        8.3. Dit aansprakelijkheidskader geldt zowel voor verzendingen van de klant naar
        Danghuan Europe S.L. als voor retourzendingen van Danghuan Europe S.L. naar de
        klant.
        <br><br>
        8.4. Indien een bevestigd verlies optreedt binnen het logistieke systeem van Danghuan,
        helpt Danghuan Europe S.L. de klant bij het indienen van een formele claim bij de
        betreffende koeriersdienst.
        <br><br>
        8.5. Aansprakelijkheid en compensatie zijn strikt beperkt tot gevallen waarin de klant het
        door Danghuan verstrekte officiële verzendlabel heeft gebruikt en het verzendtraject
        verifieerbaar is.
        <br><br>
        8.6. In geval van een bevestigd verlies bedraagt de compensatie niet meer dan de
        uiteindelijke geschatte inruilwaarde van het toestel, zoals vastgesteld vóór bevestiging
        van het verlies.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKEL 9 – PERSOONSGEGEVENS EN AVG-NALEVING</strong>
        <br><br>
        9.1. Alle persoonsgegevens die door klanten worden verstrekt tijdens deelname aan het
        Inruilprogramma, worden verwerkt in volledige overeenstemming met de toepasselijke
        wetgeving inzake gegevensbescherming, waaronder de Verordening (EU) 2016/679
        (Algemene Verordening Gegevensbescherming – AVG) voor inwoners van de EU, en
        de UK General Data Protection Regulation (UK GDPR) en de Data Protection Act 2018
        voor inwoners van het Verenigd Koninkrijk. Danghuan Europe S.L. treedt op als
        verwerkingsverantwoordelijke en neemt passende technische en organisatorische
        maatregelen om de vertrouwelijkheid, integriteit en veiligheid van alle persoonsgegevens
        te waarborgen die in het kader van het Inruilprogramma worden verwerkt.
        <br><br>
        9.2. De verzamelde gegevens omvatten, maar zijn niet beperkt tot: naam, achternaam,
        e-mailadres, postadres, telefoonnummer, bankrekening, identificatiedocumenten, IMEI
        van het ingeruilde toestel, en antwoorden die in het evaluatieformulier zijn verstrekt.
        <br><br>
        9.3. De gegevens worden uitsluitend verwerkt voor de volgende doeleinden:
        identiteitsverificatie, verwerking en beoordeling van het inruilverzoek, beheer van de
        inzameling en verzending van het toestel, klantenondersteuning, boekhouding en
        uitvoering van betalingen. Er worden geen persoonsgegevens gebruikt voor
        marketingdoeleinden en deze worden niet gedeeld met derden zonder uitdrukkelijke
        toestemming, behalve waar dit wettelijk verplicht is.
        <br><br>
        9.4. De gegevens worden alleen bewaard zolang dit noodzakelijk is om de
        inruiltransactie af te ronden en te voldoen aan wettelijke verplichtingen. Tenzij wettelijk
        anders vereist, worden alle klantgegevens binnen 30 kalenderdagen na voltooiing van
        het inruilproces en de eindbetaling verwijderd. Bepaalde gegevens kunnen echter tot 90
        dagen worden bewaard wanneer dit noodzakelijk is voor wettelijke controles,
        betalingsafstemming, fraudeonderzoek of merkpartners-audits, in overeenstemming met
        de wetgeving inzake gegevensbescherming.
        <br><br>
        9.5. De klant is als enige verantwoordelijk voor het veilig wissen van alle persoonlijke
        informatie van het toestel vóór verzending. Dit omvat contacten, berichten,
        afbeeldingen, apps, e-mails, browsegeschiedenis, accounts en vertrouwelijke inhoud.
        <br><br>
        9.6. De klant moet tevens alle actieve SIM- en microSD-kaarten verwijderen en alle
        beveiligingsfuncties uitschakelen, zoals schermvergrendelingen, wachtwoorden en
        gekoppelde cloudaccounts (bijv. Apple iCloud, Google-account, Samsung Find My
        Mobile). Het niet naleven hiervan kan ertoe leiden dat het toestel als niet in aanmerking
        komend wordt beschouwd.
        <br><br>
        9.7. Verdere informatie over de verwerking van persoonsgegevens en de rechten van
        klanten (zoals inzage, correctie, verwijdering, beperking of bezwaar) is te vinden in het
        volledige privacybeleid op de officiële website van Danghuan Europe S.L.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKEL 10 – FRAUDE- EN NIET-NALEVINGSBELEID</strong>
        <br><br>
        10.1. Inzendingen die valse verklaringen bevatten of betrekking hebben op toestellen die
        op een zwarte lijst staan, geleased, gemanipuleerd of niet eigendom van de indiener zijn,
        worden gediskwalificeerd zonder enige compensatie.
        <br><br>
        10.2. Danghuan Europe S.L. behoudt zich het recht voor om dergelijke deelnemers uit
        te sluiten van huidige en toekomstige inruilprogramma's.
        <br><br>
        10.3. In gevallen waarin sprake is van fraude, identiteitsdiefstal of pogingen om de
        geschiktheidscriteria te omzeilen voor commerciële doeleinden, kunnen gerechtelijke
        stappen worden ondernomen.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKEL 11 – OVERMACHT</strong>
        <br><br>
        11.1. In geval van natuurrampen, overheidsbeperkingen, pandemieën, arbeidsconflicten
        of transportstoringen die buiten de redelijke controle van Danghuan Europe S.L. vallen,
        kan Danghuan Europe S.L. de inruilservice tijdelijk opschorten zonder enige
        aansprakelijkheid.
        <br><br>
        11.2. Eventuele vertragingen of tekortkomingen in de uitvoering die voortvloeien uit
        dergelijke overmachtsituaties worden niet beschouwd als een contractbreuk.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKEL 12 – TOEPASSELIJK RECHT EN BEVOEGDE RECHTBANK</strong>
        <br><br>
        12.1. Deze Algemene Voorwaarden worden beheerst door en geïnterpreteerd in
        overeenstemming met het recht van Spanje. Dit doet geen afbreuk aan andere
        beschermingsrechten die de consument kan hebben op grond van zijn of haar nationale
        wetgeving.
        <br><br>
        12.2. Alle geschillen die voortvloeien uit of verband houden met deze Voorwaarden
        vallen onder de exclusieve bevoegdheid van de rechtbanken van Madrid, Spanje,
        onverminderd het recht van de consument om zijn consumentenrechten af te dwingen
        in het land van zijn woonplaats.
      </div>
    </div>
  </div>
`;